import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {PermissionsShowComponent} from '../../views/setting/permissions/permissions-show/permissions-show.component';

import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-app-log',
    templateUrl: './app-log.component.html',
    styleUrls: ['./app-log.component.scss'],
    providers: []
})
export class AppLogComponent implements OnInit {
    public logs: Log[];
    @Input() rowId;
    @Input() newDatad;
    @Input() newDatap;
    @Input() refShow;
    modalRef: NgbModalRef;

    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                public translate: TranslateService,
                private modalService: NgbModal,) {
    }

    ngOnInit() {
        this.logService.getAll(this.rowId).subscribe(
            logs => {
                this.logs = logs;
                console.log(logs);
            },
            err => {
                console.log(err);
            }
        );
    }

    close() {
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
            console.log(log);
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
        this.modalRef.componentInstance.newDatad = this.newDatad;
        this.modalRef.componentInstance.newDatap  = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/app-log/app-log.component.ts